import React from 'react';
import classNames from 'classnames';
import Placeholder from 'components/Placeholder';

import styles from './styles.module.scss';

const ABDescription = (props) => {
  const {isLoading, data} = props;
  const {accreditation_bodies_desc} = data;

  return (
    <section>
      <h3 className={styles['section__title']}>Description</h3>
      <Placeholder
        tag="p"
        rows={5}
        isReady={!isLoading}
        data={accreditation_bodies_desc}
        className={classNames(
          styles['description__content'],
          'text-secondary my-4'
        )}
      >
        {accreditation_bodies_desc}
      </Placeholder>
    </section>
  );
};

export default ABDescription;
